export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-14.jpg'),
        title: '企业移动办公',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '高效办公，节约成本，整合企业内部资源',
      description: `<p style="font-size:1.05rem">
      随着现代社会科学技术的深入发展，以及互联网行业的快速普及，企业办公移动化以及渠道移动化的需求应运而生。OA系统、ERP系统、电子邮件系统、CRM系统，已成为企业办公不可缺少的工具。企业单独开发app的能力不足，投入过大，时间过长，通过外包业务可以有效的解决这一难题。Maesinfo有着12年企业级应用运维服务的经验，帮助40多个国家的客户解决企业移动办公的难题，助力他们高效办公，节约成本，整合企业内部资源。不受场地限制的，全面确保移动的安全性，使员工能够在任何地点使用任何设备按照自己的方式工作。
      </p><p>我们确保：用户体验至上原则，业务的核心竞争力，把握移动营销新模型，身份识别的准确性保证企业安全，手机端和pc端的完美结合。</p>`
    },
    {
      title: '我们可以提供：',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-14.jpg')+`)"></span>
      <span class="list">
      <i></i>OA系统、ERP系统、CRM系统的运维服务<br/>
      <i></i>为每一个企业定制符合企业内部需求的移动办公系统以及运维服务


      </span>`
    }
  ]
}
